exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?{\"sourceMap\":true}!../assets/css/frailty_risk_check.css"), "");

// module
exports.push([module.id, "\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FrailtyRiskCheck.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-992575c0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/FrailtyRiskCheck.vue
// module id = 1Luh
// module chunks = 1